exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.overhead-dilution-lines td[data-v-6fd47aa8] {\n    background: var(--ix-background-light);\n    color: var(--ix-font-color-secondary);\n}\n.overhead-dilution-trigger[data-v-6fd47aa8] {\n    background: var(--ix-blue-light);\n    font-weight: 500;\n}\n.overhead-dilution-trigger[data-v-6fd47aa8]:hover,\n.overhead-dilution-trigger[data-v-6fd47aa8]:focus {\n    background: var(--ix-btn-blue-background);\n    border-color: var(--ix-btn-blue-border);\n    color: white;\n}\n", ""]);

// exports
